import { useMutation } from "@apollo/client";
import { ConfirmationDialog } from "../common/ConfirmationDialog";
import { useNotifications } from "../notifications";
import { DialogContentText } from "@mui/material";
import {
  DecisionAdditionalParagraph,
  DeleteDecisionAdditionalParagraphMutation,
  FetchDecisionAdditionalParagraphsQuery
} from ".";

interface Props {
  handleClose: () => void;
  paragraph: DecisionAdditionalParagraph;
  forRegistrationCommitteeItems?: boolean;
}

const DeleteDecisionAdditionalParagraphDialog = (props: Props) => {
  const notifications = useNotifications();
  const [mutate, { loading: deleting }] = useMutation<
    { decisionAdditionalParagraph: { delete: DecisionAdditionalParagraph } },
    { id: number }
  >(DeleteDecisionAdditionalParagraphMutation, {
    refetchQueries: [
      {
        query: FetchDecisionAdditionalParagraphsQuery,
        variables: { forRegistrationCommitteeItems: props.forRegistrationCommitteeItems ?? false }
      }
    ]
  });

  return (
    <>
      <ConfirmationDialog
        open={true}
        title="Delete Paragraph?"
        body={<DialogContentText>Are you sure you want to delete the paragraph?</DialogContentText>}
        confirmButtonText="Delete"
        confirm={async () => {
          await mutate({
            variables: { id: props.paragraph.id }
          });
          notifications.success("Paragraph deleted.");
          props.handleClose();
        }}
        loading={deleting}
        cancel={props.handleClose}
      />
    </>
  );
};

export default DeleteDecisionAdditionalParagraphDialog;
